import React, {Component} from 'react';
import {Bar} from 'react-chartjs-2';
import {connect} from "react-redux";
import randomColor from 'randomcolor';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import ReviewerScoreRecordTable from "./ReviewerScoreRecordTable";
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import {actions} from "../../actions";
import {withStyles} from "@material-ui/core/styles/index";

const styles = {
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        marginTop: 10,
        marginBottom: 10
    }
};


/* takes a string phrase and breaks it into separate phrases
   no bigger than 'maxwidth', breaks are made at complete words.*/
const formatLabel = function(str, maxwidth){
    var sections = [];
    var words = str.split(" ");
    var temp = "";

    words.forEach(function(item, index){
        if(temp.length > 0)
        {
            var concat = temp + ' ' + item;

            if(concat.length > maxwidth){
                sections.push(temp);
                temp = "";
            }
            else{
                if(index === (words.length-1))
                {
                    sections.push(concat);
                    return;
                }
                else{
                    temp = concat;
                    return;
                }
            }
        }

        if(index === (words.length-1))
        {
            sections.push(item);
            return;
        }

        if(item.length < maxwidth) {
            temp = item;
        }
        else {
            sections.push(item);
        }

    });

    return sections;
}

const truncateTitle = function(str) {
    if(str.length > 50) {
        return str.slice(0,47) + '...';
    } else {
        return str
    }
}


class ReviewerScoreBarChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            colors: [],
            options: {},
            artifact_id: '',
            artifact_name: ''
        };
    };

    getMax() {
        let maxScores = [];
        this.props.form.rubrics.map(function(criteria){
            maxScores.push(criteria.max_points);
        })
        console.log('the max scores array', maxScores);
        const maxScore = maxScores.reduce(function(a, b){return a+b;})
        //added to return max rounded to the next multiple of 5
        return Math.ceil(maxScore/5)*5;
    }

    createData(artifact_id) {
        let labels = [];
        let datasets = [];
        let labelsIndex = [];

        let colors = this.state.colors;

        this.props.form.rubrics.map(function(rubric, i){
            let shortenedLabel = truncateTitle(rubric.criteria_title);

            datasets.push({
                label: shortenedLabel,
                data: [],
                backgroundColor: colors[i],
                borderWidth: 1,
                borderColor: 'rgba(0,0,0,1)',

            })
        })

        for(let index in datasets) {
                for(let i = 0; i < this.props.form.reviewers.length; i++) {
                datasets[index].data.push(0);
            }
        }

        this.props.form.reviewers.map(function(reviewer){
            let shortenedLabel = formatLabel(reviewer.display_name, 10);
            labels.push(shortenedLabel);
            labelsIndex.push(reviewer.display_name);

            let artifactObject = reviewer.artifactScores.filter(artifact => {
                return artifact.artifact_id === artifact_id;
            })
            let artifact = artifactObject[0];

            if(artifact){
                for (var index in artifact.rubricScores) {
                    let dataset = datasets[index];
                    let labelIndex = labelsIndex.indexOf(reviewer.display_name);
                    if(artifact.rubricScores[index] && artifact.rubricScores[index] >= 0) {
                        dataset.data[labelIndex] = artifact.rubricScores[index];
                    }
                    datasets[index] = dataset;
                }
            }
        });

        return {
            labels: labels,
            datasets: datasets
        }
    }

    componentDidMount() {
        let colors = randomColor({
            count: this.props.form.rubrics.length,
            hue: 'red',
            format: 'rgba',
            alpha: 0.2
        });
        this.setState({colors: colors, options: {
                responsive: false,
                legend: {
                    position: 'right', // place legend on the right side of chart,
                    display: false
                },
                scales: {
                    xAxes: [{
                        stacked: true, // this should be set to make the bars stacked
                        scaleLabel: {
                            display: true,
                            labelString: 'Reviewers'
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero:true,
                            max: this.getMax()
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Score'
                        },
                        stacked: true // this also..
                    }]
                },
            }});

        this.setState({
            artifact_id: this.props.form.artifacts[0].canvas_submission_id,
            artifact_name: this.props.form.artifacts[0].canvas_assignment_name
        });

    }

    renderList(list) {
        return _.map(list, option => {
            return (
                <MenuItem key={option.canvas_submission_id} data-key={option.canvas_submission_id} data-artifact-name={option.canvas_assignment_name} value={option.canvas_submission_id} style={{width:'250'}}>
                    {option.canvas_submission_id} - {option.canvas_assignment_name}
                </MenuItem>
            );
        });
    }

    handleChange = () => (event) => {
        const name = event.nativeEvent.target.getAttribute('data-artifact-name');
        this.setState({artifact_id: event.target.value, artifact_name: name});
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid container spacing={2}>
                <Grid item key={this.state.artifact_id} xs>

                <form>
                        <TextField id="select-artifact" select label="Select Artifact" style={{width: '500px'}} value={this.state.artifact_id} onChange={this.handleChange()} margin="normal">
                            {this.renderList(this.props.form.artifacts)}
                        </TextField>
                    </form>

                        <Typography variant="h5" gutterBottom className={classes.headertitle}>
                            Artifact {this.state.artifact_id} - {this.state.artifact_name}
                        </Typography>
                        <Bar
                            data={this.createData(this.state.artifact_id)}
                            width={500}
                            height={500}
                            options={this.state.options}
                        />

                </Grid>
                <Grid item xs>
                    <ReviewerScoreRecordTable artifactId={this.state.artifact_id} reviewers={this.props.form.reviewers} rubrics={this.props.form.rubrics}/>
                </Grid>
            </Grid>

        );
    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(ReviewerScoreBarChart));

